import projection from '../generated/pwp5m1f1.json';
import { AcceptanceManifest } from '../types';

export const pwp5m1f1AcceptanceManifest = projection as AcceptanceManifest;
